var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"button-list"},_vm._l((_vm.btnList),function(btn,index){return _c('div',{key:index,staticClass:"show-button",class:{'active': _vm.active === btn},on:{"click":function($event){return _vm.btnClick(btn)}}},[_vm._v(_vm._s(btn))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }